import React from 'react';
import { Link } from 'react-router-dom';
import LoginForm from './LoginForm';
import OwnerAccessNotice from './OwnerAccessNotice';
import { MARKETPLACE_ENABLED } from '../../helpers/marketplaceEnabled';

const Login = () =>
<>
  <div className="mb-4">
    <h2 className="hl-auth__title">Inicia sesión</h2>
    <p className="hl-auth__subtitle">Accede a la administración de tu condominio.</p>
  </div>
  <LoginForm />
  <OwnerAccessNotice className="mt-4" />
  <p className="hl-auth__footer">
    ¿Administras un condominio nuevo? <Link to="/register">Regístralo</Link>
  </p>
  {MARKETPLACE_ENABLED && (
    <p className="hl-auth__footer mt-2">
      ¿Ofreces servicios para el hogar? <Link to="/register/provider">Regístrate como proveedor</Link>
    </p>
  )}
</>

export default Login;
